import { ListItemText } from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';
import React from 'react';
import { IRole } from 'types/api';

export type RoleOption = { value: string; label: string; description?: string };

export const toRoleOptions = (roles?: IRole[]): RoleOption[] =>
	roles?.map((role) => ({
		value: role.id,
		label: role.name,
		description: role.description
	})) ?? [];

export const filterRoleOptions = createFilterOptions<RoleOption>({
	stringify: (opt) => [opt.label, opt.description].filter(Boolean).join(' ')
});

// role name as the primary text with the optional description muted below it
export const renderRoleOption = (
	{
		key,
		...optionProps
	}: React.HTMLAttributes<HTMLLIElement> & { key: string },
	opt: RoleOption
) => (
	<li key={key} {...optionProps}>
		<ListItemText
			primary={opt.label}
			secondary={opt.description || undefined}
			slotProps={{ secondary: { noWrap: true } }}
		/>
	</li>
);
